/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable max-classes-per-file */
import { Modal, ModalController } from '~/scripts/services/modal/modal';

class Controller extends ModalController {
	/**
	 * @param {any} options
	 * @param {any} options
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('angular').auto.IInjectorService} $injector
	 */

	/* @ngInject */
	constructor(options, $uibModalInstance, $injector) {
		super(options, $uibModalInstance, $injector);

		this.onClick = options.onClick;
		this.onCancel = options.onCancel;

		this.affect = options.affect;
		this.actionKid = options.actionKid;
		this.affectKid = options.affectKid;
		this.kid = options.kid;
		this.options = options.options;
	}

	async create() {
		this.actions.close('aaa');
	}
}

class WFAffectModal extends Modal {
	/**
	 *
	 * @param {any} controllerData
	 * @returns {Promise<any>} Promise return
	 */
	open(controllerData) {
		return super.open({
			template:       `
<wf-form-actions
	options="$ctrl.options"
	on-click="$ctrl.onClick(controller)"
	on-cancel="$ctrl.onCancel(controller)"
	affect="$ctrl.affect"
	action-kid="$ctrl.actionKid"
	affect-kid="$ctrl.affectKid"
	kid="$ctrl.kid"
></wf-form-actions>
			`,
			controller:     Controller,
			controllerAs:   '$ctrl',
			windowTopClass: 'wf-affect-modal',
		}, controllerData);
	}
}

export { WFAffectModal };
